import React, { useState } from 'react';
import axios from 'axios';
import { UserCheck, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Sprint 34.2 — red banner shown across the top of every page when the current
 * session is an impersonation. The 'Stop' button clears the impersonation
 * cookie and reloads so we drop back into the admin's own session.
 */
export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const [stopping, setStopping] = useState(false);

  if (!user?.is_impersonated) return null;

  const handleStop = async () => {
    setStopping(true);
    try {
      await axios.post(`${API_URL}/api/admin/impersonate/stop`, {}, { withCredentials: true });
      if (refresh) await refresh();
      window.location.assign('/admin');
    } catch (e) {
      window.location.assign('/admin');
    }
  };

  const impEmail = user.impersonator?.email || 'an admin';
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-error text-white px-4 py-2 flex items-center justify-center gap-3 text-sm shadow-lg" role="alert" aria-live="assertive">
      <UserCheck className="w-4 h-4" />
      <span>
        Impersonating <strong>{user.email}</strong> (real account: {impEmail}).
      </span>
      <button
        onClick={handleStop}
        disabled={stopping}
        className="inline-flex items-center gap-1 px-3 py-2.5 rounded-md bg-white/20 hover:bg-white/30 font-medium disabled:opacity-50 min-h-[44px]"
        data-testid="stop-impersonation-btn"
      >
        <X className="w-3 h-3" /> {stopping ? 'Stopping…' : 'Stop impersonating'}
      </button>
    </div>
  );
}
